/**
 * DemoDisclosure — the required disclosure block that MUST appear
 * above any CTA on demo professional detail pages.
 *
 * Copy locked by CP2 dispatch — do NOT edit without a matching
 * update in the backend seed disclosure bio.
 */
import React from "react";
import { AlertCircle } from "lucide-react";

export const DEMO_DISCLOSURE_TEXT =
  "Demo profile — shown only to demonstrate how verified professional " +
  "listings will appear in the marketplace. This is not an active service " +
  "provider.";

export default function DemoDisclosure({ id = "demo-profile-disclosure" }) {
  return (
    <div
      id={id}
      data-testid="demo-profile-disclosure"
      role="note"
      className="rounded-2xl px-5 py-4 md:px-6 md:py-5 flex gap-3 items-start"
      style={{
        background: "rgba(167,139,250,0.10)",
        border: "1px solid rgba(167,139,250,0.42)",
        color: "var(--v2-text, #F5F5F0)",
      }}
    >
      <span
        aria-hidden="true"
        className="mt-0.5 inline-flex h-8 w-8 rounded-full items-center justify-center flex-shrink-0"
        style={{ background: "rgba(167,139,250,0.20)", color: "var(--v2-accent-strong, #5D50C8)" }}
      >
        <AlertCircle className="h-4 w-4" />
      </span>
      <div>
        <div
          className="text-[11px] uppercase tracking-[0.2em] font-semibold mb-1"
          style={{ color: "var(--v2-accent-strong, #5D50C8)" }}
        >
          Demo profile disclosure
        </div>
        <p className="text-sm md:text-base leading-relaxed" style={{ color: "var(--v2-text-secondary, #EDEDE8)" }}>
          {DEMO_DISCLOSURE_TEXT}
        </p>
      </div>
    </div>
  );
}
